import { FiltersPreferences } from '@if/mui'
import FilterListAltIcon from '@mui/icons-material/FilterListAlt'
import SearchIcon from '@mui/icons-material/Search'
import { Button, Grid, TextField, Toolbar } from '@mui/material'
import { FilterPreferenceActionBar } from '@src/components/FilterPreferenceActionBar'
import { BROWSE_CREDIT_APPLICATIONS_FILTERS_ENABLED_KEY } from '@src/contexts/preferences-context'
import { useCallback, useState, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { CreditDashboardFilters } from '../../data/types/CreditDashboardEntry'
import MainActions from './MainActions'
import SearchFilter from './SearchFilters'

interface Props {
  filterValues: CreditDashboardFilters
  resetFilter: () => void
  searchTerm: string
  setSearchTerm: (value: string) => void
  applyFilter: (data: CreditDashboardFilters) => void
  preferences: FiltersPreferences
}

const DataGridHeader = ({
  filterValues,
  resetFilter,
  searchTerm,
  setSearchTerm,
  applyFilter,
  preferences,
}: Props): JSX.Element => {
  const { t } = useTranslation()

  const [openSearchFilters, setOpenSearchFilters] = useState<boolean>(false)

  const onCancel = useCallback(() => {
    setOpenSearchFilters(false)
  }, [setOpenSearchFilters])

  const onApplyFilters = () => {
    applyFilter({
      ...filterValues,
      searchTerm,
    })
  }

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          onApplyFilters()
        }}
      >
        <Toolbar sx={{ mb: 1 }}>
          <Grid container columnSpacing={2} flexGrow={1} alignItems="start">
            <Grid sx={{ mt: 1 }}>
              <MainActions />
            </Grid>
            <Grid
              size={{
                md: 3,
              }}
              sx={{ mt: 1 }}
            >
              <TextField
                label={t('browseCreditApplications.dataGridHeader.appClientName')}
                onChange={(e) => {
                  setSearchTerm(e.target.value)
                }}
                value={searchTerm}
                fullWidth
                helperText={t('browseCreditApplications.dataGridHeader.searchHelperText')}
              />
            </Grid>
            <Grid flexGrow={1}>
              <Button type="submit" size="large">
                <SearchIcon fontSize="large" color="action" />
              </Button>
              <Button
                aria-label={t('common.filter')}
                size="large"
                variant="contained"
                onClick={() => {
                  setOpenSearchFilters(true)
                }}
              >
                <FilterListAltIcon fontSize="medium" sx={{ color: 'white' }} />
              </Button>
            </Grid>
            <Grid flexShrink={0} sx={{ pt: 1 }}>
              <FilterPreferenceActionBar
                preferences={preferences}
                preferenceKey={BROWSE_CREDIT_APPLICATIONS_FILTERS_ENABLED_KEY}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </form>
      {openSearchFilters ? (
        <SearchFilter
          open={openSearchFilters}
          filterValues={filterValues}
          resetFilter={resetFilter}
          applyFilter={applyFilter}
          onCancel={onCancel}
        />
      ) : null}
    </>
  )
}

export default DataGridHeader
